console.log("checkout js loaded");
$(document).ready( function() {
		$("#delivery_date").datepicker();
        $("#delivery_date").datepicker("option", "dateFormat", "DD, d MM, yy" );
  
  		$("#delivery_date_RTC_picker").datepicker();
        $("#delivery_date_RTC_picker").datepicker("option", "dateFormat", "DD, d MM, yy" );
  		$("#delivery_date_RTC_picker").datepicker("option", "minDate", "+4d" );
  		$("#delivery_date_RTC_picker").prop('disabled', true);
  		
  		$('#RTC_Delivery #delivery_RTC_type').attr('value', "1-3 Days Express");
  		$('#RTC_Delivery #delivery_date_RTC').attr('value', "1-3 Days Express");

  $(".timepicker").picktim({
  mode: 'h12'
});

  
});

$('#RTC_Delivery #delivery_RTC_type').change( function() {
//   alert($('#RTC_Delivery #delivery_RTC_type').val());
  if ($('#RTC_Delivery #delivery_RTC_type').val() == "Advance") {
    $('#RTC_Delivery #delivery_date_RTC').attr('value', "");
    $("#delivery_date_RTC_picker").prop('disabled', false);
  } else {
    $("#delivery_date_RTC_picker").datepicker('setDate', null);
    $("#delivery_date_RTC_picker").prop('disabled', true);
    $('#RTC_Delivery #delivery_date_RTC').attr('value', "1-3 Days Express");
  }
});


$('#RTC_Delivery #delivery_date_RTC_picker').change( function() {
//   alert($('#RTC_Delivery #delivery_date').val());
//   $('#RTC_Delivery #delivery_date_RTC').valid();
  $('#RTC_Delivery #delivery_date_RTC').attr('value', $('#RTC_Delivery #delivery_date_RTC_picker').val());
});


// 
//       
//     });



               
//                $('.timepicker').wickedpicker(options);